<template>
  <div class="vaccinum-inlet">
    <el-button
      type="primary"
      @click="goPage('VaccinumOperate')"
    >预约追踪日报</el-button>
    <el-button
      type="primary"
      @click="goPage('VaccinumTable')"
    >招商系客户明细</el-button>
  </div>
</template>

<script>
export default {
  methods: {
    goPage(name) {
      this.$router.push({ name });
    },
  },
};
</script>

<style lang="scss" scoped>
.vaccinum-inlet {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
  .el-button {
    margin: 10px 0;
    width: 140px;
  }
}
</style>